import OrderProgressItem, { OrderProgressItemProps } from './OrderProgressItem';

export type { OrderProgressItemProps };
export default OrderProgressItem;
